/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'warning': {
    viewBox: '0 0 16 16',
    data: `<g><path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,15c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7C15,11.9,11.9,15,8,15z"/><rect x="7.5" y="3.5" width="1" height="5.5"/><circle cx="8" cy="11.5" r="1"/></g>`
  }
})
